exports = module.exports = require("../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".set-all-params__wrapper{display:flex;justify-content:center;text-align:center;font-size:18px}.set-all-params .modal-window__icon{top:-20px;left:-20px;width:46px;height:46px;border-radius:50%}.set-all-params .modal-window__icon--alert{font-size:40px}body[dir=rtl] .set-all-params .modal-window__icon {\n  right: -20px;\n}\n", ""]);

// exports
